var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-bar"},[_c('div',{staticClass:"page-bar-main"},[_c('a-pagination',{attrs:{"showLessItems":"","total":_vm.total},on:{"change":_vm.changePage},model:{value:(_vm.current),callback:function ($$v) {_vm.current=$$v},expression:"current"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }